import React, { useEffect } from "react";
import "./Logout.css";

import logo from "../../assets/img/logo-500.png";

export default function Logout() {
  useEffect(() => {
    const currUrl = new URL(window.location.href);
    const redirectUrl = decodeURIComponent(
      currUrl.searchParams.get("redirect_to") || "/"
    );

    console.log("Redirecting to", redirectUrl);
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("accessToken");
    setTimeout(() => {
      window.location.href = redirectUrl;
    }, 1000);
  }, []);

  return (
    <div className='login-page'>
      {/* background grid */}
      <div className='grid-bg' aria-hidden='true' />

      <div className='login-card' role='main'>
        {/* Logo */}
        <div className='login-logo-wrap'>
          <img src={logo} alt='Excel MEC' className='login-logo' />
        </div>

        {/* Heading */}
        <h1 className='login-title'>
          <strong>Logging out...</strong>
        </h1>
        <p className='login-sub'>Please wait while we securely sign you out.</p>
      </div>
    </div>
  );
}
